// src/components/empty/EmptyPortfolio.jsx
export default function EmptyPortfolio({ onAddHolding }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '48px 24px',
      textAlign: 'center',
      fontFamily: "'IBM Plex Mono', 'Courier New', monospace",
    }}>
      <style>{`@keyframes ep-pulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:0.5;transform:scale(0.8)}}`}</style>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gap: '6px',
        marginBottom: '32px',
      }}>
        {Array.from({ length: 15 }).map((_, i) => (
          <div key={i} style={{
            width: '8px', height: '8px',
            borderRadius: '50%',
            background: i < 3 ? '#3ddc84' : '#1a2332',
            opacity: i < 3 ? 1 : 0.4,
            animation: i < 3 ? `ep-pulse 2s ease-in-out ${i * 0.3}s infinite` : 'none',
          }} />
        ))}
      </div>
      <h3 style={{
        color: '#ffffff',
        fontSize: '14px',
        letterSpacing: '0.1em',
        marginBottom: '8px',
        fontFamily: "'IBM Plex Mono', 'Courier New', monospace",
        fontWeight: 700,
      }}>
        YOUR PORTFOLIO IS EMPTY
      </h3>
      <p style={{
        color: '#6b7280',
        fontSize: '12px',
        lineHeight: 1.7,
        maxWidth: '280px',
        marginBottom: '24px',
        fontFamily: "'IBM Plex Mono', 'Courier New', monospace",
      }}>
        Add your first holding to unlock your Risk Score,
        P&L tracking, and portfolio history.
      </p>
      <button
        onClick={onAddHolding}
        style={{
          padding: '10px 24px',
          background: '#3ddc84',
          border: 'none',
          borderRadius: '6px',
          color: '#060a0f',
          fontFamily: "'IBM Plex Mono', 'Courier New', monospace",
          fontSize: '13px',
          fontWeight: 700,
          cursor: 'pointer',
          letterSpacing: '0.05em',
        }}
      >
        ADD FIRST HOLDING →
      </button>
    </div>
  );
}
